module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5f4208a6b7257c456c018d57efc8a7e9.svg";